export default __webpack_public_path__ + "static/media/logo3.aea523e3.png";